import React, { useState, useEffect, useMemo } from 'react';
import { Table, Row, Col } from 'antd';
import { getLoanAnalysis } from '../../../../api/EmiPayments';
import { useSelector } from 'react-redux';
import ZCard from '../../../Card/Index';
import { CurrencyFormatWithDecimal } from '../../../../helper/CurrencyFormate';
import { CURRENCY } from '../../../../utils/ConstantData';
import dayjs from 'dayjs';

const LoanAnalysis = () => {

  const [loanDetails, setLoanDetails] = useState([]);
  const [emiReturnData, setEmiReturnData] = useState(null);
  const { reportDetails, selectedAccountId } = useSelector(({ reportDetails }) => reportDetails);


  

  const { data, columns } = useMemo(() => {
    let newList = [];
    loanDetails.forEach(({ statementPeriod = {}, monthlyDetails = [] }) => {
      let item = statementPeriod;
      monthlyDetails.forEach((monthData) => {
        item[`${monthData.month.replace(/ /g, "-")}-date`] = monthData?.date || "-";
        item[`${monthData.month.replace(/ /g, "-")}-emiAmtPaid`] = monthData?.emiPaidAmt || 0;
        item[`${monthData.month.replace(/ /g, "-")}-prevDayBalance`] = monthData?.prevDayBalance || 0;
      })
      newList.push(item);
    })
    let columns = [
      {
        title: '12 Months (Statement Period)',
        children: [
          {
            title: 'EMI Paid',
            dataIndex: 'emiPaidCount',
            key: 'emiPaid',
            width: 150,
          },
          {
            title: 'EMI Bounce (₹)',
            dataIndex: 'emiBounce',
            key: 'emiBounce',
            align: 'right',
            className: 'no-wrap-column',
            width: 150,
          },
          {
            title: 'EMI Amt Paid (₹)',
            dataIndex: 'emiPaidAmt',
            key: 'emiPaidAmt',
            align: 'right',
            className: 'no-wrap-column',
            width: 150,
            render: (value) => (
              CurrencyFormatWithDecimal(
                value || '0',
                null,
                CURRENCY
              )
            )
          },
          {
            title: 'Avg Previous Day Balance (₹)',
            dataIndex: 'avgPrevDayBalance',
            key: 'avgPrevDayBalance',
            align: 'right',
            className: 'no-wrap-column',
            width: 220,
            render: (value) => (
              CurrencyFormatWithDecimal(
                value || '0',
                null,
                CURRENCY
              )
            )
          }
        ]
      }
    ];
  
    let firstRow = loanDetails.length > 0 ? loanDetails[0]?.monthlyDetails || [] : []
    firstRow.forEach(({ month }) => {
      let _column = {
        title: month,
        width: 500,
        children: [
          { title: 'Date', dataIndex: `${month.replace(/ /g, "-")}-date`, key: `${month.toLowerCase()}Date`, width: 100 },
          {
            title: 'EMI Amt Paid (₹)', dataIndex: `${month.replace(/ /g, "-")}-emiAmtPaid`, key: `${month.toLowerCase()}EmiAmtPaid`, width: 180, align: 'right',
            className: 'no-wrap-column',
            render: (value) => (value) ? CurrencyFormatWithDecimal(value) : "-"
          },
          {
            title: 'Previous Day Balance (₹)', dataIndex: `${month.replace(/ /g, "-")}-prevDayBalance`, key: `${month.toLowerCase()}PrevDayBalance`, width: 200, align: 'right',
            className: 'no-wrap-column',
            render: (value, record, index) => {
              const isLastRow = index === data.length - 1; // Check if it's the last row
              const isZeroValue = value === 0 || value === '0';
              return isLastRow || isZeroValue ? '-' : CurrencyFormatWithDecimal(value);
            },
          }
        ]
      }
      columns.push(_column);
    })

    columns.push({
      title: 'Remarks (Bounces/DPD)',
      dataIndex: 'remarks',
      key: 'remarks',
      width: 150,
      render: (value) => value || "-",
    });

    return { data: newList, columns: columns };
  }, [loanDetails])




  const columns1 = [
    {
      title: '12 Months (Statement Period)',
      children: [
        {
          title: 'No',
          dataIndex: 'no',
          key: 'no',
          width: 80,
          fixed: 'left',
        },
        {
          title: 'Lender',
          dataIndex: 'lender',
          key: 'lender',
          width: 150,
        },
        {
          title: 'Loan Credit (₹)',
          dataIndex: 'loanCredit',
          key: 'loanCredit',
          align: 'right',
          className: 'no-wrap-column',
          width: 150,
          render: (value) => (
            CurrencyFormatWithDecimal(
              value || '0',
              null,
              CURRENCY
            )
          )
        },
        {
          title: 'Loan Debit (₹)',
          dataIndex: 'loanDebit',
          key: 'loanDebit',
          align: 'right',
          className: 'no-wrap-column',
          width: 150,
          render: (value) => (
            CurrencyFormatWithDecimal(
              value || '0',
              null,
              CURRENCY
            )
          )
        },
        {
          title: 'EMI Debit (₹)',
          dataIndex: 'emiDebit',
          key: 'emiDebit',
          align: 'right',
          className: 'no-wrap-column',
          width: 150,
          render: (value) => (
            CurrencyFormatWithDecimal(
              value || '0',
              null,
              CURRENCY
            )
          )
        },
        {
          title: 'EMI Started On',
          dataIndex: 'emiStartedOn',
          key: 'emiStartedOn',
          width: 150,
        },
        {
          title: 'EMI Obligation Status',
          dataIndex: 'emiObligationStatus',
          key: 'emiObligationStatus',
          width: 150,
          colSpan: 0
        },
        {
          title: 'EMI Obligation (₹)',
          dataIndex: 'emiObligationAmt',
          key: 'emiObligationAmt',
          align: 'right',
          className: 'no-wrap-column',
          width: 150,
          colSpan: 2,
          render: (value) => (
            CurrencyFormatWithDecimal(
              value || '0',
              null,
              CURRENCY
            )
          )
        },
        {
          title: 'Bank Name (EMI Running)',
          dataIndex: 'bankNameEmiRunning',
          key: 'bankNameEmiRunning',
          width: 250,
          render: (value) => value || "-"
        }
      ]
    }
  ];
  


  const columns3 = [
    {
      title: 'Months',
      dataIndex: 'month',
      key: 'month',
    },
    {
      title: `Amount (₹)`,
      dataIndex: 'emiReturnChargesAmt',
      key: 'amount',
      align: 'right',
      className: 'no-wrap-column',
      render: (value) => (
        CurrencyFormatWithDecimal(
          value || '0',
          null,
          CURRENCY
        )
      )
    },
    {
      title: 'Count',
      dataIndex: 'emiReturnChargesCount',
      key: 'amount2',
    },
    {
      title: 'EMI Bonus Count',
      dataIndex: 'emiBounceCount',
      key: 'amount3',
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        let aggregate = selectedAccountId !== 'all'? false : true;
        let account_id = selectedAccountId !== 'all'? selectedAccountId : reportDetails?.report?.reportId;
        const response = await getLoanAnalysis(account_id, aggregate);
        setLoanDetails(response.loanAnalysis.loanDetails);
        setEmiReturnData(response.loanAnalysis.emiReturnCharges);
      } catch (error) {
        console.log("ERROR", error);
      }
    }

    if (selectedAccountId) fetchData();
  }, [selectedAccountId]);


  console.log("EXTRA DATA", data);
  return (
    <div >
      <div style={{display: 'flex'}}>
      
      <Row gutter={[16, 16]} style={{alignItems: 'stretch'}}>
        <Col xs={24} sm={24} md={12} style={{ height: '100%' }}>
        <ZCard style={{ height: '100%' }}>
        <ZCard.Title>Loan Details</ZCard.Title>
          <Table
            dataSource={loanDetails}
            columns={columns1}
            pagination={false}
            style={{ marginBottom: '0px' }}
            bordered
            scroll={{ y: 240 }}
            rowClassName={(record, index) => {
              return loanDetails.length - 1 === index ? "fw-500" : ""
            }}
          />
          </ZCard>
          </Col>
          
          <Col xs={24} sm={24} md={12}>
          <ZCard>
        <ZCard.Title>Repayment Details</ZCard.Title>
          <Table
            dataSource={data}
            columns={columns}
            pagination={false}
            bordered
            scroll={{ y: 240 }}
          />
          </ZCard>
          </Col>
      </Row>
      </div>
      <Row style={{ marginTop: '20px' }}>
        <Col span={24}>
          <ZCard>
            <ZCard.Title>EMI Return Charges</ZCard.Title>
            <Table
              dataSource={emiReturnData}
              columns={columns3}
              pagination={false}
              bordered
              scroll={{ y: 240 }}
              rowClassName={(record, index) => {
                return emiReturnData.length - 1 === index ? "fw-500" : ""
              }}
            />
          </ZCard>
        </Col>
      </Row>
    </div>
  );
}

export default LoanAnalysis;
